// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DcIY","left":"styles_left__QRSuE"};